import NewsBanner from "../../assets/images/image-1920x720.jpg";
import { useNews } from "../../http/useNews";
import { NewsCard, NewsFeatured } from "./components/NewsCard";

export const News = () => {
  const { data: newsData } = useNews();
  const [featured, ...rest] = newsData?.articles ?? [];

  return (
    <div>
      <section className="Banner NewsListBanner" style={{ backgroundImage: `url(${NewsBanner})` }}>
        <div className="ovelay"></div>
        <div className="container position-relative">
          <h1 className="text-white" data-aos="fade-up">
            {newsData?.articleType?.name}
          </h1>
        </div>
      </section>
      <section className="NewsPage">
        <div className="container">
          {featured && (
            <div className="mb-5" data-aos="fade-up">
              <NewsFeatured article={featured} solo />
            </div>
          )}
          <div className="row g-4">
            {rest.map((article) => (
              <div className="col-lg-4 col-md-6" data-aos="fade-up" key={article.id}>
                <NewsCard article={article} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
